import { io } from 'socket.io-client';

console.log(
  '[INIT] bigTournamentLongSocket.js'
);

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  'http://localhost:5000';


const bigTournamentLongSocket =
  io(
    `${SOCKET_URL}/big-tournament-long`,
    {
      autoConnect: false,
      transports: ['websocket'],
    }
  );


const eventQueue = [];

const ANCHOR =
  'bigTournament:lastActiveTableId';


function clearBigTournamentAnchor() {
  try {
    localStorage.removeItem(
      ANCHOR
    );

    sessionStorage.removeItem(
      ANCHOR
    );
  } catch (_) {}
}


export function syncBigTournamentActiveTable(
  cb
) {
  if (
    !bigTournamentLongSocket.connected
  ) {
    return;
  }


  bigTournamentLongSocket.emit(
    'big_getMyActiveTable',
    (payload) => {

      if (payload?.tableId) {

        try {
          localStorage.setItem(
            ANCHOR,
            String(payload.tableId)
          );
        } catch (_) {}

      } else {

        clearBigTournamentAnchor();
      }


      if (
        typeof cb === 'function'
      ) {
        cb(payload || null);
      }
    }
  );
}


bigTournamentLongSocket.on(
  'connect',
  () => {

    console.log(
      '[CLIENT] bigTournamentLongSocket connected'
    );


    while (
      eventQueue.length > 0
    ) {
      const {
        event,
        payload,
      } = eventQueue.shift();

      bigTournamentLongSocket.emit(
        event,
        payload
      );
    }


    let storedId = null;

    try {
      storedId =
        sessionStorage.getItem(
          ANCHOR
        ) ||
        localStorage.getItem(
          ANCHOR
        );
    } catch (_) {}


    const username =
      localStorage.getItem(
        'username'
      ) || '';


    if (
      storedId &&
      username
    ) {

      const tableId =
        Number(storedId);


      if (
        Number.isInteger(tableId) &&
        tableId > 0
      ) {

        bigTournamentLongSocket.emit(
          'joinLongTable',
          {
            longTableId:
              tableId,

            playerUsername:
              username,
          }
        );


        bigTournamentLongSocket.emit(
          'longFetchData',
          tableId
        );
      }
    }


    syncBigTournamentActiveTable();
  }
);


export function safeEmit(
  event,
  payload
) {
  if (
    bigTournamentLongSocket.connected
  ) {
    bigTournamentLongSocket.emit(
      event,
      payload
    );
  } else {
    eventQueue.push({
      event,
      payload,
    });
  }
}


export function ensureBigTournamentLongSocketAuthAndConnect() {
  try {

    const token =
      localStorage.getItem(
        'token'
      ) || '';

    const username =
      localStorage.getItem(
        'username'
      ) || '';


    bigTournamentLongSocket.auth = {
      token,
      username,
    };

  } catch (_) {}


  if (
    !bigTournamentLongSocket.connected &&
    !bigTournamentLongSocket.connecting
  ) {
    bigTournamentLongSocket.connect();
  }
}


export function ensureBigTournamentLongSocket(
  username
) {
  if (!username) return;


  const token =
    localStorage.getItem(
      'token'
    ) || '';


  bigTournamentLongSocket.auth = {
    token,
    username,
  };


  if (
    !bigTournamentLongSocket.connected &&
    !bigTournamentLongSocket.connecting
  ) {
    bigTournamentLongSocket.connect();
  }
}


bigTournamentLongSocket.on(
  'big_tournamentTable',
  ({
    tableId,
  }) => {

    if (!tableId) return;

    try {
      localStorage.setItem(
        ANCHOR,
        String(tableId)
      );
    } catch (_) {}
  }
);


bigTournamentLongSocket.on(
  'long_clearActiveTable',
  clearBigTournamentAnchor
);

bigTournamentLongSocket.on(
  'long_tableClosed',
  clearBigTournamentAnchor
);

bigTournamentLongSocket.on(
  'long_gameFinished',
  clearBigTournamentAnchor
);


export function forgetBigTournamentAnchor() {
  clearBigTournamentAnchor();
}


export default bigTournamentLongSocket;